import { render, staticRenderFns } from "./homeT.vue?vue&type=template&id=2a45767a"
import script from "./homeT.vue?vue&type=script&lang=js"
export * from "./homeT.vue?vue&type=script&lang=js"
import style0 from "./homeT.vue?vue&type=style&index=0&id=2a45767a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports